<!-- 
Scheduled jobs listing page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="breadcrumbs"
      title="Scheduled jobs"
      user-guide-topic="administration-scheduled-jobs"
    />
    <our-actions-bar 
      :actions="actions" 
      xs-breakpoint
      @create="showCreateDialog=true" 
      @run="showRunDialog=true"
    />
    <scheduled-job-listing ref="listing"/>
    <scheduled-job-edit-dialog v-model="showCreateDialog" :create="true" @changed="openNewJob"/>
    <scheduled-job-run-overdue-jobs-dialog v-model="showRunDialog" />
  </div>
</template>

<script>
import ScheduledJobListing from "@/components/scheduled-jobs/ScheduledJobListing.vue";
import ScheduledJobEditDialog from "@/components/scheduled-jobs/ScheduledJobEditDialog.vue";
import ScheduledJobRunOverdueJobsDialog from "@/components/scheduled-jobs/ScheduledJobRunOverdueJobsDialog.vue";
import * as claim from "@/store/claim-types";

export default {
  name: "ScheduledJobs",
  components: { ScheduledJobListing, ScheduledJobEditDialog, ScheduledJobRunOverdueJobsDialog },
  data() {
    return {
      showCreateDialog: false,
      showRunDialog: false,
      breadcrumbs: [{ text: "Scheduled jobs" }]
    };
  },
  computed: {
    actions() {
      const actions = [];
      if (this.canEdit) {
        actions.push({ text: "Add scheduled job", emit: "create", icon: "add_circle_outline" });
      }
      actions.push({ text: "Run overdue jobs", emit: "run", icon: "slideshow", disabled: !this.anyOverdueJobs });
      return actions;
    },
    canEdit() {
      return this.$store.getters.claims.includes(claim.SCHEDULED_JOBS_EDIT);
    },
    anyOverdueJobs() {
      return this.$store.state.scheduledJobs.listing.data.some(j => j.isOverdue);
    }
  },
  methods: {
    openNewJob(job) {
      this.$router.push(`/scheduled-jobs/${job.id}`);
    }
  }
};
</script>
